<template>
    <div class="clearfix card-wrap " :class="disabled?'disabled':'pointer'">
        <div class="fl">
            <span class="card-icon icon iconfont" :class="'icon-jt-'+icon"></span>
        </div>
        <div class="fl">
            <h3 class="title">{{title}}</h3>
            <p class="desc">{{desc}}</p>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ToolCard",
        props:{
            title:String,
            desc:String,
            icon:String,
            disabled:{
                type:Boolean,
                required: false,
                default: false,
            },
        },
    }
</script>

<style lang="scss" scoped>
    .card-wrap{
        .card-icon{
            display: inline-block;
            width: 36px;
            height: 36px;
            font-size: 36px;
            margin-right: 20px;
            color: #66b1ff;
            margin-top: 3px;
        }
        .title{
            margin-bottom: 6px;
        }
        &:hover{
            .title{
                color: #66b1ff;
            }
        }
        &.disabled{
            .card-icon{
                color: #999;
            }
            .title,.desc{
                color: #999;
            }
        }
    }
</style>
